<script setup lang="ts">
import type { Challenge } from '~/types/challenge'

const props = defineProps<{
  challenge: Challenge
}>()

const ranking = computed(() => props.challenge?.ranking ?? [])

const isUserHighlighted = (userId: number) => {
  if (!props.challenge?.influencers_challenge || !props.challenge?.influencers) {
    return false
  }

  return props.challenge.influencers.includes(userId)
}
</script>

<template>
  <div>
    <ChallengeRankingRow
      v-for="rank in ranking"
      :key="rank.user_id"
      :rank="rank"
      :challenge="challenge"
      :highlight-user="isUserHighlighted(rank.user_id)"
    />
  </div>
</template>
